import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Icon } from "@vds/icons";
import { TEXT } from "../../constants/errorTemplateConstants";
import "./ErrorTemplate.css";

const ErrorTemplate = ({
  title = TEXT.ERROR_TEMPLATE_TITLE,
  description = TEXT.ERROR_TEMPLATE_DESC,
  onRefresh,
  showRefreshButton = true,
  testId = "error-template",
  templateType="error"
}) => {
  return (
    <div className={templateType === "error" ? "error-template-container" : "info-template-container"} data-testid={testId}>
      <div className="error-content">
        <div className="error-icon-container">
          {templateType === "info" ? <InfoOutlinedIcon /> : <ReportProblemOutlinedIcon />}
        </div>
        <div className="error-title">{title}</div>

        <div className="error-description-container">
          <div className="error-description">{description}</div>

          {showRefreshButton && onRefresh && (
            <div className="error-refresh-button" data-testid="error-template-refresh" onClick={onRefresh}>
              <Icon name="sync" ariaHidden={true} size="small" color="#000000" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorTemplate;
